var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('folder-details',{attrs:{"items":_vm.items,"on-region-chosen":_vm.loadItems,"loading":_vm.loading,"show-region-chooser":true,"page-title":"Wissenswertes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }